<div class="claims-wrapper">
  <div class="claims-header" (click)="goBack()">
    <img src="../../../../assets/images/arrow-right.png" alt="" />
    Track Claim
  </div>

  <div class="claims-body">
    <div class="top">
      <div class="claims-body-left">
        <app-claim-id-card></app-claim-id-card>
        <!-- {{selectedClaim.claimStatus==="Repudiated" ? 'View Repudiation Letter' : 'View Settlement Letter'}} -->

        <!-- <app-pdf-block [pdfName]="'Discrepancy Letter.pdf'"></app-pdf-block>
        <app-pdf-block [pdfName]="'Intimation letter.pdf'"></app-pdf-block> -->
        <!-- <app-action-block class="withdraw" [actionName]="'Withdraw Request'"
        *ngIf="claimDetails.claimStatus !== 'Claim settled' && claimDetails.claimStatus !== 'Closed'"
          [actionDesc]="'Option to cancel your claim request.'" [actionButtonText]="'Withdraw'"></app-action-block> -->
        <app-action-block class="needHelp" [actionName]="'Need Help?'"
          [actionDesc]="'Raise a query or request assistance anytime.'"
          [actionButtonText]="'Contact Us'" (actionButtonClicked)="redirectToContactUs()"></app-action-block>
          
        <!-- <app-action-block  *ngIf="(claimJourney.s7 !== null && claimJourney.s7.isStageCompleted) ||
        (claimJourney.s8 !== null && claimJourney.s8.isStageCompleted) ||
        (claimJourney.s9 !== null && claimJourney.s9.isStageCompleted) ||
        (claimJourney.s10 !== null && claimJourney.s10.isStageCompleted)" 
        class="needHelp" [actionName]="'View Letter'"
          [actionDesc]="'View Letter.'"
          [actionButtonText]="'View Letter'" (actionButtonClicked)="downloadFile()"></app-action-block>
 -->

        <app-action-block *ngIf="(claimJourney.s7 !== null && claimJourney.s7.isStageCompleted) ||
        (claimJourney.s8 !== null && claimJourney.s8.isStageCompleted)" class="needHelp"
          [actionName]="'Payment Details'" [actionDesc]="''"
          [actionButtonText]="'Payment Details'" (actionButtonClicked)="openPaymentDetailsModal()"></app-action-block>
          
        <app-action-block *ngIf="claimDetails.claimStatus == 'Claim settled'" class="needHelp"
          [actionName]="'Claim Breakdown'" [actionDesc]="'See a detailed view of a summary of your settled claim'"
          [actionButtonText]="'View Details'" (actionButtonClicked)="openClaimBreakdownModal()"></app-action-block>
          
        <!-- Backdrop + claim-breakdown-modal -->
        <div class="backdrop" *ngIf="isClaimBreakdownModalOpen" (click)="closeClaimBreakdownModal()">
          <div class="claim-breakdown-modal" (click)="$event.stopPropagation()">
            <div>
              <div class="claim-breakdown-modal-header">
                <div>
                  <div class="header-font">
                    <img src="../../../../assets/images/arrow-right.png" alt="" *ngIf="viewState === 'showDisallowedDetails'" (click)="viewState = 'showClaimBreakDown'"/>

                    {{
                    viewState === 'showClaimBreakDown' ? 'Claim Breakdown' : 'Disallowed
                    Amount'
                    }}
                  </div>
                  <p class="header-desc-font" *ngIf="viewState === 'showClaimBreakDown'">
                    Here’s a summary of your claim
                  </p>
                </div>

                <button class="close-btn" (click)="closeClaimBreakdownModal()">✕</button>
              </div>

              <ng-container *ngIf="viewState === 'showClaimBreakDown'; else showDisallowedDetails">
                <div class="claim-breakdown-modal-body">
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Claim Amount Requested</div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.claimAmt | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row cursor-pointer" (click)="viewState = 'showDisallowedDetails'">
                    <div class="claim-breakdown-key">Disallowed Amount</div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.disallowedAmount | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Sanctioned Amount</div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.sanctionAmount | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <div class="claim-breakdown-subheading">Deductions</div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Compulsory Deduction </div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.compulsoryDeduction | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Co-payment Deduction </div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.copaymentDeduction | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Net Sanctioned Amount (C+(D+E))</div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.netSanctionAmount | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <div class="claim-breakdown-subheading">Tax</div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Service Tax</div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.serviceTax | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">TDS Amount</div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.tdsAmount | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                  <hr />
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Final Payable Amount</div>
                    <div class="claim-breakdown-value">
                      {{ claimDetails.finalPayableAmount | currency: 'INR':'symbol':'1.0-2':'en-IN' }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #showDisallowedDetails>
                <div class="disallowed-amount-modal-body">
                  <div class="disallowed-amount-row">
                    <div class="total-disallowed-amount">
                      <div>Total Claimed Amount</div>
                      <div class="highlight-black">{{ claimDetails.claimAmt | currency: 'INR':'symbol':'1.0-2':'en-IN'}}</div>
                    </div>
                    <div class="total-disallowed-amount">
                      <div>Total Disallowed Amount</div>
                      <div class="highlight">{{ claimDetails.disallowedAmount | currency: 'INR':'symbol':'1.0-2':'en-IN'}}</div>
                    </div>
                  </div>
                  <div class="disallowed-amount-row" *ngFor="let detail of disallowedDetails">
                    <div class="total-disallowed-amount">
                      <div>Bill Description</div>
                      <div>{{ detail.billDescription }}</div>
                    </div>
                    <div class="total-disallowed-amount">
                      <div>Claim Amount</div>
                      <div>{{ detail.claimedAmount | currency: 'INR':'symbol':'1.0-2':'en-IN'}}</div>
                    </div>
                    <div class="total-disallowed-amount">
                      <div>Sub Bill Type</div>
                      <div>{{ detail.subBillTypeDescription }}</div>
                    </div>
                    <div class="total-disallowed-amount">
                      <div>Disallowed Amount</div>
                      <div>{{ detail.disallowedAmount | currency: 'INR':'symbol':'1.0-2':'en-IN'}}</div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="claim-breakdown-modal-footer">
              <button (click)="closeClaimBreakdownModal()">Close</button>
            </div>
          </div>
        </div>


        <!-- Backdrop + payment-details-modal -->
        <div class="backdrop" *ngIf="isPaymentDetailsOpen">
          <div class="claim-breakdown-modal" (click)="$event.stopPropagation()">
            <div>
              <div class="claim-breakdown-modal-header">
                <div>
                  <div class="header-font">
                    Payment Details
                  </div>
                  <p class="header-desc-font" *ngIf="claimPaymentDetails.length > 0">
                    Here’s a summary of your claim
                  </p>
                </div>

                <button class="close-btn"  (click)="this.isPaymentDetailsOpen = false;">✕</button>
              </div>

              <ng-container>
                <div class="claim-breakdown-modal-body claim-breakdown-row claim-breakdown-key message" *ngIf="claimPaymentDetails.length === 0">{{claimPaymentDetails.length === 0 ? "For Payment details please contact your Relationship Manager" : ""}}</div>
                <div class="claim-breakdown-modal-body" *ngIf="claimPaymentDetails.length > 0" >
                  <div class="claim-breakdown-modal-body" *ngFor="let claimPaymentDetail of claimPaymentDetails">
                    <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Payee Name</div>
                    <div style="text-align:right;">
                      {{ claimPaymentDetail?.payeename }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row" (click)="viewState = 'showDisallowedDetails'">
                    <div class="claim-breakdown-key"> Amount</div>
                    <div style="text-align:right;">
                      {{ claimPaymentDetail?.paidAmounts | currency: 'INR':'symbol':'1.0-2':'en-IN'  }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Txn. ID/ Cheque Number</div>
                    <div style="text-align:right;">
                      {{ claimPaymentDetail?.transactionNumber }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Transaction Date </div>
                    <div style="text-align:right;">
                      {{ claimPaymentDetail?.transactionDate }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Account Number </div>
                    <div style="text-align:right;">
                      {{ claimPaymentDetail?.accountNumber  }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Bank Name</div>
                    <div style="text-align:right;">
                      {{ claimPaymentDetail?.bankName  }}
                    </div>
                  </div>
                  <div class="claim-breakdown-row">
                    <div class="claim-breakdown-key">Mode of Payment</div>
                    <div style="text-align:right;">
                      {{ claimPaymentDetail?.modeofPayment }}
                    </div>
                  </div>
                    </div>
                  
                </div>
              </ng-container>

            </div>

            <div class="claim-breakdown-modal-footer">
              <button (click)="this.isPaymentDetailsOpen = false;">Close</button>
            </div>
          </div>
        </div>
      </div>
      <div class="claims-body-right">
        <app-track-claim-details-mobile></app-track-claim-details-mobile>
      </div>
    </div>

    <div class="bottom">
      <div class="title">
        Documents Uploaded
      </div>
      <div class="body">
        <!-- {{uploadedDocsList | json}} -->
        <app-pdf-block *ngFor="let doc of uploadedDocsList" [document]="doc"></app-pdf-block>
      </div>
    </div>
  </div>
</div>